/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/status/status_styles';



/* ========== ~~~~~~~~~~ STATUS ~~~~~~~~~~ ========== */
class Status extends Component {
	constructor(props) {
		super(props);
		this.state = { selected: this.indicatorOnly() ? true : false };
	}
	indicatorOnly = () => this.props.type === 'indicator' ? true : false;
	handleClick = (e) => {
		if (this.indicatorOnly()) return null; // we're only a visual element that should not be clickable
		this.setState({ selected: this.state.selected ? false : true });
		this.props.onClick(this.showText(), this.props.live);
	};
	showText = () => this.props.live ? 'online' : 'offline';
	setVariant = () => this.props.variant === 'dot' ? 'dot' : 'text';
	render() {
		return (
			<div className={`status ${this.props.classes.status} ${this.showText()} variant-${this.setVariant()} selected-${this.state.selected}`} onClick={this.handleClick}>
		        <span className={`text`}>{this.showText()}</span>
		    </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Status);
